import React from "react";

import { Modal } from "antd";

import * as S from "./styles";
import { TBlockedPopupModal } from "./types";

const ModalBlockedPopUp: React.FC<TBlockedPopupModal> = ({
  onClose,
  visible,
}) => {
  return (
    <Modal
      title={<S.ModalTitle>PopUp bloqueado</S.ModalTitle>}
      visible={visible}
      onCancel={onClose}
    >
      <S.Container>
        <S.ModalDescription>
          Parece que seu navegador está bloqueando pop-ups. Para visualizar a
          fatura, por favor, habilite pop-ups em seu navegador e tente
          novamente.
        </S.ModalDescription>

        <S.ModalButton onClick={onClose}>Fechar</S.ModalButton>
      </S.Container>
    </Modal>
  );
};

export default ModalBlockedPopUp;
